export default __webpack_public_path__ + "static/media/ic-design.9539da4f.svg";